import React from 'react';
import { Spinner } from './Spinner';
const Loading = ({ size, color, className, spinnerClassName, isFade }) => {
    return (React.createElement("div", { className: className ? className : '' },
        React.createElement(Spinner, { size: size, color: color, isFade: isFade, className: spinnerClassName ? spinnerClassName : '' })));
};
export { Loading };
//# sourceMappingURL=Loading.js.map